import React from 'react';
import classNames from 'classnames';
import {Icons} from 'helpers/enums/icons';

export default function Icon(props) {
  const { iconType, className, hasCircle, children, position, fillColor, strokeColor, active, iconSize } = props;
  const IconVariant = Icons[iconType];
  const iconClass = classNames(
    'icon',
    {
      'icon_active': active,
      [`icon_${iconSize}`]: iconSize,
      [`mix-icon_fillColor${fillColor}`]: fillColor,
      [`mix-icon_strokeColor${strokeColor}`]: strokeColor
    },
    className
  );
  const iconVariantClasses = classNames(
    'icon_animate',
    {
      [`icon_${position}`]: position
    }
  );

  return (
    <i className={iconClass} key={0}>
      <IconVariant className={iconVariantClasses} />
      {children}
    </i>
  );
}



// WEBPACK FOOTER //
// ./src/client/components/icons/icon.jsx